import React, { memo } from 'react';
import PropTypes from 'prop-types';
import pages from '../../../define/pages';
import cn from 'classnames';

import Card, {
  CardContentPosition,
  CardSizes,
} from '../../../ui-components/Card/Card';
import Image, {
  ImageShapes,
  ImageSizes,
} from '../../../ui-components/Image/Image';
import Typography, {
  TypographyVariants,
  TypographyWeights,
} from '../../../ui-components/Typography/Typography';

function SmartSearchCategoryCard({ item, classNames }) {
  return (
    <Card
      className={cn(classNames)}
      image={
        <Image
          source={item?.thumbnail_image}
          size={ImageSizes.large}
          shape={ImageShapes.rounded}
          overlaid
          alt={'Activity cover image'}
        />
      }
      link={`${window.location.origin}${pages.catalogue}?category=${item?.id}&query=${item.title}`}
      content={
        <Typography
          variant={TypographyVariants.p3}
          weight={TypographyWeights.regular}
        >
          {item?.title}
        </Typography>
      }
      size={CardSizes.large}
      contentPosition={CardContentPosition.bottom}
    />
  );
}

SmartSearchCategoryCard.propTypes = {
  item: PropTypes.object,
  classNames: PropTypes.string,
};

export default memo(SmartSearchCategoryCard);
